import React from "react";
import { Route, Redirect } from "react-router-dom";

const AuthenticatedRoute = ({ component: Component, auth, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      auth.isAuthenticated() ? (
        <Component auth={auth} {...props} />
      ) : (
        <div
          style={{
            backgroundColor: "white",
            position: "fixed",
            width: "100%",
            height: "100%",
            top: 0,
            left: 0,
            zIndex: 1000
          }}
        >
          <Redirect
            to={{
              pathname: "/login",
              state: { from: props.location }
            }}
          />
        </div>
      )
    }
  />
);

export default AuthenticatedRoute;
